import moment from "moment";

export const getFormattedDate = (date) => {
	return moment(date).format('DD MMM YYYY hh:mm:ss A');
}